import React from "react";

interface myComponentProps {
  text?: string;
  color?: string;
}

const TextColorFragment = ({ color, text }: myComponentProps) => {
  return (
    <span style={{ color: color || "", textTransform: "capitalize" }}>
      {text || ""}
    </span>
  );
};

export default TextColorFragment;
